import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TopicOptionsPage } from './topic-options';

@NgModule({
  declarations: [
    TopicOptionsPage,
  ],
  imports: [
    IonicPageModule.forChild(TopicOptionsPage),
  ],
})
export class TopicOptionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/topic/topic-options/topic-options.module.ts